import { render } from "./IconWarning.vue?vue&type=template&id=556d82e1"
import script from "./IconWarning.vue?vue&type=script&lang=js"
export * from "./IconWarning.vue?vue&type=script&lang=js"
script.render = render

export default script